import React from "react";
import {Link} from "react-router-dom";
import CategoryIcon from "../../../icons/CategoryIcon";
import ProductIcon from "../../../icons/ProductIcon";
import SellerIcon from "../../../icons/SellerIcon";
import PricelistIcon from "../../../icons/PricelistIcon";
import PaymentIcon from "../../../icons/PaymentIcon";
import CloseIcon from "../../../icons/CloseIcon";
import SettingsIcon from "../../../icons/SettingsIcon";
import FunctionIcon from "../../../icons/functionIcon";
import LoaderCircle from "../../../loader/LoaderCircle";
import MagicIcon from "../../../icons/MagicIcon";
import "../../../../css/page/content/screen/ScreenToolsBar.css";

const ScreenToolsBar = props => {
    const { typeSelected, action, loadingCategories, loadingProducts, loadingPricelists, loadingSellers, loadingPaymentMethods, loadingFunctions } = props
    const links = [
        /*{
            item: "magicTool",
            label: "Baguette magique",
            icon: <MagicIcon />,
            action: () => { action('magicTool') },
            link: null
        },*/
        {
            item: "categories",
            label: "Catégories",
            icon: <CategoryIcon />,
            action: () => { action('categories') },
            link: null
        },
        {
            item: "products",
            label: "Produits",
            icon: <ProductIcon />,
            action: () => { action('products') },
            link: null
        },
        {
            item: "pricelists",
            label: "Tarifs",
            icon: <PricelistIcon />,
            action: () => { action('pricelists') },
            link: null
        },
        {
            item: "sellers",
            label: "Vendeurs",
            icon: <SellerIcon />,
            action: () => { action('sellers') },
            link: null
        },
        {
            item: "paymentMethods",
            label: "Règlements",
            icon: <PaymentIcon />,
            action: () => { action('paymentMethods') },
            link: null
        },
        {
            item: "functions",
            label: "Fonctions",
            icon: <FunctionIcon />,
            action: () => { action('functions') },
            link: null
        },
        {
            item: "settings",
            label: "Réglages",
            icon: <SettingsIcon />,
            action: () => { action('settings') },
            link: null
        },
        {
            item: "close",
            label: "Fermer",
            icon: <CloseIcon />,
            action: null,
            link: "/screens"
        }
    ];

    const buildItem = (link, index) => {
        if (link.action !== null) {
            return <div key={index} className={"toolItem " + link.item + "-tool" + (typeSelected === link.item ? " selected" : "")} onClick={link.action}>
                {
                    buildIcon(link)
                }
                <div className={"containerText"}>
                    <span>{link.label}</span>
                </div>
            </div>
        }
        else if (link.link !== null) {
            return <Link key={index} to={link.link}>
                <div className={"toolItem " + link.item}>
                    {
                        buildIcon(link)
                    }
                    <div className={"containerText"}>
                        <span>{link.label}</span>
                    </div>
                </div>
            </Link>
        }
    }
    const buildIcon = link => {
        switch (link.item)
        {
            case "categories":
                if (loadingCategories)
                    return <LoaderCircle display="loader screenTollsBar" stroke={"#FFFFFF"} strokeWidth="8" />
                else
                    return link.icon;
            case "products":
                if (loadingProducts)
                    return <LoaderCircle display="loader screenTollsBar" stroke={"#FFFFFF"} strokeWidth="8" />
                else
                    return link.icon;
            case "pricelists":
                if (loadingPricelists)
                    return <LoaderCircle display="loader screenTollsBar" stroke={"#FFFFFF"} strokeWidth="8" />
                else
                    return link.icon;
            case "sellers":
                if (loadingSellers)
                    return <LoaderCircle display="loader screenTollsBar" stroke={"#FFFFFF"} strokeWidth="8" />
                else
                    return link.icon;
            case "paymentMethods":
                if (loadingPaymentMethods)
                    return <LoaderCircle display="loader screenTollsBar" stroke={"#FFFFFF"} strokeWidth="8" />
                else
                    return link.icon;
            case "functions":
                if (loadingFunctions)
                    return <LoaderCircle display="loader screenTollsBar" stroke={"#FFFFFF"} strokeWidth="8" />
                else
                    return link.icon;
            default: return link.icon;
        }
    }

    return (<div id={"screenToolsBar"} className={"screenToolsBar"}>
            {
                links.map((link, index) => buildItem(link, index))
            }
        </div>
    )
}

export default ScreenToolsBar
